import { render, staticRenderFns } from "./send-demographic-request-popup.vue?vue&type=template&id=352558fa&"
import script from "./send-demographic-request-popup.vue?vue&type=script&lang=ts&"
export * from "./send-demographic-request-popup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports